var map = {
	"./BIFI-logo.svg": 1518,
	"./avax-pairs/COM-AVAX.png": 1519,
	"./avax-pairs/DAI-AVAX.png": 1520,
	"./avax-pairs/ETH-AVAX.png": 1521,
	"./avax-pairs/LYD-AVAX.png": 1522,
	"./avax-pairs/OLIVE-AVAX.png": 1523,
	"./avax-pairs/OLIVE-USDT.png": 1524,
	"./avax-pairs/PNG-AVAX.png": 1525,
	"./avax-pairs/SNOB-AVAX.svg": 1526,
	"./avax-pairs/SNOB3P.png": 1527,
	"./avax-pairs/USDT-AVAX.png": 1528,
	"./avax-pairs/ZETH.svg": 1529,
	"./banners/CakeBanner.svg": 917,
	"./bbond-256.png": 1530,
	"./bbond-512.png": 1531,
	"./binance-wallet.png": 1532,
	"./bnb-pairs/AAVE-BNB.svg": 1533,
	"./bnb-pairs/ADA-BNB.svg": 1534,
	"./bnb-pairs/ALICE-BNB.svg": 1535,
	"./bnb-pairs/ALPA-BNB.svg": 1536,
	"./bnb-pairs/ALPACA-BNB.png": 1537,
	"./bnb-pairs/ALPHA-BNB.svg": 1538,
	"./bnb-pairs/APYS-BNB.svg": 1539,
	"./bnb-pairs/ARPA-BNB.svg": 1540,
	"./bnb-pairs/ASR-BNB.svg": 1541,
	"./bnb-pairs/ATA-BNB.svg": 1542,
	"./bnb-pairs/ATM-BNB.svg": 1543,
	"./bnb-pairs/ATOM-BNB.svg": 1544,
	"./bnb-pairs/AUTO-BNB.png": 1545,
	"./bnb-pairs/AVAX-BNB.svg": 1546,
	"./bnb-pairs/BAKE-BNB.png": 1547,
	"./bnb-pairs/BALBT-BNB.svg": 1548,
	"./bnb-pairs/BAND-BNB.svg": 1549,
	"./bnb-pairs/BAT-BNB.svg": 1550,
	"./bnb-pairs/BCH-BNB.svg": 1551,
	"./bnb-pairs/BDO-BNB.svg": 1552,
	"./bnb-pairs/BEL-BNB.svg": 1553,
	"./bnb-pairs/BELT-BNB-BELT.png": 1554,
	"./bnb-pairs/BELT-BNB.svg": 1555,
	"./bnb-pairs/BFI-BNB.svg": 1556,
	"./bnb-pairs/BHC-BNB.png": 1557,
	"./bnb-pairs/BIFI-BNB.png": 1558,
	"./bnb-pairs/BIFI-BNB.svg": 1559,
	"./bnb-pairs/BITI-BNB.png": 1560,
	"./bnb-pairs/BLIQ-BNB.png": 1561,
	"./bnb-pairs/BLK-BNB.svg": 1562,
	"./bnb-pairs/BLZ-BNB.svg": 1563,
	"./bnb-pairs/BMXX-BNB.svg": 1564,
	"./bnb-pairs/BONDLY-BNB.svg": 1565,
	"./bnb-pairs/BOPEN-BNB.svg": 1566,
	"./bnb-pairs/BOR-BNB.svg": 1567,
	"./bnb-pairs/BRY-BNB.svg": 1568,
	"./bnb-pairs/BSCX-BNB.svg": 1569,
	"./bnb-pairs/BTC-BNB.png": 1570,
	"./bnb-pairs/BTCB-BNB.svg": 1571,
	"./bnb-pairs/BTCST-BNB.svg": 1572,
	"./bnb-pairs/BTT-BNB.svg": 1573,
	"./bnb-pairs/BUNNY-BNB.svg": 1574,
	"./bnb-pairs/BUSD-BNB.png": 1575,
	"./bnb-pairs/BUSD-BNB.svg": 1576,
	"./bnb-pairs/BUX-BNB.svg": 1577,
	"./bnb-pairs/BXBTC-BNB.svg": 1578,
	"./bnb-pairs/C98-BNB.svg": 1579,
	"./bnb-pairs/CAKE-BNB.svg": 1580,
	"./bnb-pairs/CELR-BNB.svg": 1581,
	"./bnb-pairs/CGG-BNB.svg": 1582,
	"./bnb-pairs/COM-BNB.png": 1583,
	"./bnb-pairs/COMP-BNB.svg": 1584,
	"./bnb-pairs/COS-BNB.svg": 1585,
	"./bnb-pairs/COTI-BNB.svg": 1586,
	"./bnb-pairs/CRED-BNB.png": 1587,
	"./bnb-pairs/CTK-BNB.svg": 1588,
	"./bnb-pairs/CYC-BNB.svg": 1589,
	"./bnb-pairs/DAI-BNB.svg": 1590,
	"./bnb-pairs/DEGO-BNB.svg": 1591,
	"./bnb-pairs/DEP-BNB.png": 1592,
	"./bnb-pairs/DFT-BNB.svg": 1593,
	"./bnb-pairs/DITTO-BNB.svg": 1594,
	"./bnb-pairs/DODO-BNB.svg": 1595,
	"./bnb-pairs/DOGE-BNB-PCS.svg": 1596,
	"./bnb-pairs/DOGE-BNB.svg": 1597,
	"./bnb-pairs/DOT-BNB.svg": 1598,
	"./bnb-pairs/DRUGS-BNB.png": 1599,
	"./bnb-pairs/DUSK-BNB.svg": 1600,
	"./bnb-pairs/EASY-BNB.svg": 1601,
	"./bnb-pairs/EGLD-BNB.svg": 1602,
	"./bnb-pairs/EOS-BNB.svg": 1603,
	"./bnb-pairs/EPS-BNB.svg": 1604,
	"./bnb-pairs/ETC-BNB.svg": 1605,
	"./bnb-pairs/ETH-BNB.svg": 1606,
	"./bnb-pairs/EZ-BNB.svg": 1607,
	"./bnb-pairs/FIL-BNB.svg": 1608,
	"./bnb-pairs/FINE-BNB.svg": 1609,
	"./bnb-pairs/FRONT-BNB.svg": 1610,
	"./bnb-pairs/FTM-BNB.svg": 1611,
	"./bnb-pairs/FTS-BNB.svg": 1612,
	"./bnb-pairs/FUEL-BNB.png": 1613,
	"./bnb-pairs/GOLD-BNB.png": 1614,
	"./bnb-pairs/GUM-BNB.svg": 1615,
	"./bnb-pairs/GUNS-BNB.png": 1616,
	"./bnb-pairs/HARD-BNB.svg": 1617,
	"./bnb-pairs/HELMET-BNB.svg": 1618,
	"./bnb-pairs/HGET-BNB.svg": 1619,
	"./bnb-pairs/HYFI-BNB.svg": 1620,
	"./bnb-pairs/HZN-BNB.svg": 1621,
	"./bnb-pairs/INJ-BNB.svg": 1622,
	"./bnb-pairs/IOTA-BNB.svg": 1623,
	"./bnb-pairs/ITAM-BNB.svg": 1624,
	"./bnb-pairs/JBTCB-BNB.svg": 1625,
	"./bnb-pairs/JDOT-BNB.svg": 1626,
	"./bnb-pairs/JGN-BNB.png": 1627,
	"./bnb-pairs/JGN-BNB.svg": 1628,
	"./bnb-pairs/JTWT-BNB.svg": 1629,
	"./bnb-pairs/JULD-BNB.svg": 1630,
	"./bnb-pairs/JUNI-BNB.svg": 1631,
	"./bnb-pairs/JUV-BNB.svg": 1632,
	"./bnb-pairs/JXVS-BNB.svg": 1633,
	"./bnb-pairs/KALM-BNB.svg": 1634,
	"./bnb-pairs/KEBAB-BNB.png": 1635,
	"./bnb-pairs/KEYFI-BNB.svg": 1636,
	"./bnb-pairs/KTN-BNB.svg": 1637,
	"./bnb-pairs/LIEN-BNB.svg": 1638,
	"./bnb-pairs/LINK-BNB.svg": 1639,
	"./bnb-pairs/LIT-BNB.svg": 1640,
	"./bnb-pairs/LMT-BNB.svg": 1641,
	"./bnb-pairs/LTC-BNB.svg": 1642,
	"./bnb-pairs/LTO-BNB.svg": 1643,
	"./bnb-pairs/MATIC-BNB.svg": 1644,
	"./bnb-pairs/MBOX-BNB.svg": 1645,
	"./bnb-pairs/MDX-BNB.png": 1646,
	"./bnb-pairs/NAR-BNB.png": 1647,
	"./bnb-pairs/NAUT-BNB.svg": 1648,
	"./bnb-pairs/NEAR-BNB.svg": 1649,
	"./bnb-pairs/NRV-BNB.svg": 1650,
	"./bnb-pairs/ODDZ-BNB.svg": 1651,
	"./bnb-pairs/OG-BNB.svg": 1652,
	"./bnb-pairs/ONT-BNB.svg": 1653,
	"./bnb-pairs/PBTC-BNB.svg": 1654,
	"./bnb-pairs/PERL-BNB.svg": 1655,
	"./bnb-pairs/POPEN-BNB.svg": 1656,
	"./bnb-pairs/PSG-BNB.svg": 1657,
	"./bnb-pairs/REEF-BNB.svg": 1658,
	"./bnb-pairs/SFP-BNB.svg": 1659,
	"./bnb-pairs/SHIB-BNB.svg": 1660,
	"./bnb-pairs/SNX-BNB.svg": 1661,
	"./bnb-pairs/SOAK-BNB.svg": 1662,
	"./bnb-pairs/SPG-BNB.svg": 1663,
	"./bnb-pairs/STEAM-BNB.svg": 1664,
	"./bnb-pairs/SUTER-BNB.svg": 1665,
	"./bnb-pairs/SWAMP-BNB.svg": 1666,
	"./bnb-pairs/SWGB-BNB.svg": 1667,
	"./bnb-pairs/SWINGBY-BNB.svg": 1668,
	"./bnb-pairs/SWIRL-BNB.png": 1669,
	"./bnb-pairs/SWTH-BNB.svg": 1670,
	"./bnb-pairs/SXP-BNB.svg": 1671,
	"./bnb-pairs/TDOGE-BNB.svg": 1672,
	"./bnb-pairs/TEN-BNB.svg": 1673,
	"./bnb-pairs/THUGS-BNB.png": 1674,
	"./bnb-pairs/TKO-BNB.svg": 1675,
	"./bnb-pairs/TLM-BNB.svg": 1676,
	"./bnb-pairs/TRADE-BNB.svg": 1677,
	"./bnb-pairs/TRX-BNB.svg": 1678,
	"./bnb-pairs/TWT-BNB.svg": 1679,
	"./bnb-pairs/TYPH-BNB.png": 1680,
	"./bnb-pairs/UNFI-BNB.svg": 1681,
	"./bnb-pairs/UNI-BNB.svg": 1682,
	"./bnb-pairs/USDC-BNB.svg": 1683,
	"./bnb-pairs/USDT-BNB.svg": 1684,
	"./bnb-pairs/VAPOR-BNB.png": 1685,
	"./bnb-pairs/VIDT-BNB.svg": 1686,
	"./bnb-pairs/VRT-BNB.svg": 1687,
	"./bnb-pairs/WATCH-BNB-APE.svg": 1688,
	"./bnb-pairs/WATCH-BNB.svg": 1689,
	"./bnb-pairs/WEX-BNB.png": 1690,
	"./bnb-pairs/WIN-BNB.svg": 1691,
	"./bnb-pairs/WSOTE-BNB.svg": 1692,
	"./bnb-pairs/XED-BNB.svg": 1693,
	"./bnb-pairs/XEND-BNB.svg": 1694,
	"./bnb-pairs/XRP-BNB.svg": 1695,
	"./bnb-pairs/XTZ-BNB.svg": 1696,
	"./bnb-pairs/XVS-BNB.svg": 1697,
	"./bnb-pairs/YFI-BNB.svg": 1698,
	"./bnb-pairs/YFII-BNB.svg": 1699,
	"./bnb-pairs/ZEC-BNB.svg": 1700,
	"./bnb-pairs/ZEE-BNB.svg": 1701,
	"./bnb-pairs/ZIL-BNB.svg": 1702,
	"./bnb-pairs/bROOBEE-BNB.svg": 1703,
	"./bnb-pairs/bTRI-BNB.png": 1704,
	"./bnb-pairs/pCWS-BNB.svg": 1705,
	"./bnb-pairs/typh-bnb.svg": 1706,
	"./bomb-1024.png": 1707,
	"./bomb-200x200.png": 1708,
	"./bomb-256.png": 1709,
	"./bomb-512.png": 1710,
	"./bomb32.png": 1711,
	"./bshare-256.png": 1712,
	"./bshare-512.png": 1713,
	"./busd-pairs/ADA-BUSD.png": 1714,
	"./busd-pairs/ALPACA-BUSD.svg": 1715,
	"./busd-pairs/BAKE-BUSD.png": 1716,
	"./busd-pairs/BCFX-BUSD.svg": 1717,
	"./busd-pairs/BIFI-BUSD.png": 1718,
	"./busd-pairs/BTCB-BUSD.svg": 1719,
	"./busd-pairs/BTR-BUSD.svg": 1720,
	"./busd-pairs/BUSD-USDC.svg": 1721,
	"./busd-pairs/DAI-BUSD.png": 1722,
	"./busd-pairs/DAI-BUSD.svg": 1723,
	"./busd-pairs/DEXE-BUSD.svg": 1724,
	"./busd-pairs/DFD-BUSD.svg": 1725,
	"./busd-pairs/FOR-BUSD.svg": 1726,
	"./busd-pairs/HAKKA-BUSD.svg": 1727,
	"./busd-pairs/HOO-BUSD.svg": 1728,
	"./busd-pairs/IOTX-BUSD.svg": 1729,
	"./busd-pairs/KEBAB-BUSD.png": 1730,
	"./busd-pairs/KUN-BUSD.svg": 1731,
	"./busd-pairs/LINA-BUSD.svg": 1732,
	"./busd-pairs/LTC-BUSD.png": 1733,
	"./busd-pairs/MATH-BUSD.svg": 1734,
	"./busd-pairs/MDX-BUSD.png": 1735,
	"./busd-pairs/MTRG-BUSD.svg": 1736,
	"./busd-pairs/MX-BUSD.svg": 1737,
	"./busd-pairs/NULS-BUSD.svg": 1738,
	"./busd-pairs/OIN-BUSD.svg": 1739,
	"./busd-pairs/ONE-BUSD.svg": 1740,
	"./busd-pairs/PMON-BUSD.svg": 1741,
	"./busd-pairs/QKC-BUSD.svg": 1742,
	"./busd-pairs/RAMP-BUSD.svg": 1743,
	"./busd-pairs/SWAMP-BUSD.svg": 1744,
	"./busd-pairs/TPT-BUSD.svg": 1745,
	"./busd-pairs/TUSD-BUSD.svg": 1746,
	"./busd-pairs/TXL-BUSD.svg": 1747,
	"./busd-pairs/UBXT-BUSD.svg": 1748,
	"./busd-pairs/USDC-BUSD.svg": 1749,
	"./busd-pairs/USDT-BUSD.png": 1750,
	"./busd-pairs/USDT-BUSD.svg": 1751,
	"./busd-pairs/UST-BUSD.svg": 1752,
	"./busd-pairs/VAI-BUSD.svg": 1753,
	"./busd-pairs/WELL-BUSD.svg": 1754,
	"./busd-pairs/WMASS-BUSD.svg": 1755,
	"./busd-pairs/XMARK-BUSD.svg": 1756,
	"./busd-pairs/XRP-BUSD.png": 1757,
	"./cake-pairs/BROOBEE-CAKE.svg": 1758,
	"./cake-pairs/CAKE-BUSD.svg": 1759,
	"./cake-pairs/NAR-CAKE.svg": 1760,
	"./cake-pairs/NYA-CAKE.svg": 1761,
	"./cake-pairs/STAX-CAKE.svg": 1762,
	"./cake-pairs/ampl-bsc-mp-busd.svg": 1763,
	"./cake-pairs/btcb-eth.svg": 1764,
	"./cake-pairs/chr-busd.svg": 1765,
	"./cake-pairs/deri-busd.svg": 1766,
	"./cake-pairs/eth-usdc.svg": 1767,
	"./cake-pairs/hotcross-bnb.svg": 1768,
	"./cake-pairs/rfox-bnb.svg": 1769,
	"./crow/crow.png": 1770,
	"./degens/ADA-BNB.svg": 1771,
	"./degens/BANANA-DOT-BNB.svg": 1772,
	"./degens/BANANA-EPS-BNB.svg": 1773,
	"./degens/BANANA-GUARD-BNB.svg": 1774,
	"./degens/BANANA-SFP-BNB.svg": 1775,
	"./degens/BANANA-SUSHI-BNB.svg": 1776,
	"./degens/BANANA-TWT-BNB.svg": 1777,
	"./degens/BANANA-XRP-BNB.svg": 1778,
	"./degens/BANANA-XVS-BNB.svg": 1779,
	"./degens/BANANA.svg": 1780,
	"./degens/BGO.png": 1781,
	"./degens/BIFI-BNB-banana.svg": 1782,
	"./degens/BIFI-BNB.svg": 1783,
	"./degens/BITI.png": 1784,
	"./degens/BLZD-BNB.png": 1785,
	"./degens/BLZD-BUSD.png": 1786,
	"./degens/BLZD.png": 1787,
	"./degens/DND.png": 1788,
	"./degens/FTS-BNB.svg": 1789,
	"./degens/FUEL-BNB.svg": 1790,
	"./degens/GOAL-BUSD.png": 1791,
	"./degens/IRON.png": 1792,
	"./degens/LINK-BNB.svg": 1793,
	"./degens/NAUT.png": 1794,
	"./degens/PALM.png": 1795,
	"./degens/SAT-BNB.png": 1796,
	"./degens/SAT-BUSD.png": 1797,
	"./degens/SBGO.png": 1798,
	"./degens/SOUP-BNB.svg": 1799,
	"./degens/SOUPS-BNB.svg": 1800,
	"./degens/SPACE-BNB.png": 1801,
	"./degens/SPACE-BUSD.png": 1802,
	"./degens/STEEL.png": 1803,
	"./degens/WINGS-BNB-BUSD.svg": 1804,
	"./degens/WINGS-BNB.svg": 1805,
	"./degens/WINGS-BUSD.svg": 1806,
	"./degens/WINGS-USDC-BUSD.svg": 1807,
	"./degens/WINGS.svg": 1808,
	"./degens/ZEFI-BNB.svg": 1809,
	"./degens/ZEFI-BUSD.svg": 1810,
	"./degens/ape-bnb.png": 1811,
	"./degens/banana-bnb.svg": 1812,
	"./degens/banana-busd.svg": 1813,
	"./degens/banana-ltc-bnb.svg": 1814,
	"./degens/brew-bnb.svg": 1815,
	"./degens/brew-busd.svg": 1816,
	"./degens/garuda-bnb.png": 1817,
	"./degens/garuda-usdc.png": 1818,
	"./degens/garuda-usdt.png": 1819,
	"./degens/grand-bnb.png": 1820,
	"./degens/grand.png": 1821,
	"./degens/mash-bnb.png": 1822,
	"./degens/mash-busd.png": 1823,
	"./degens/mash.png": 1824,
	"./degens/mfrm-bnb.png": 1825,
	"./degens/palm-bnb.png": 1826,
	"./degens/palm-busd.png": 1827,
	"./degens/panther-bnb.png": 1828,
	"./degens/panther-busd.png": 1829,
	"./degens/quant-busd.png": 1830,
	"./degens/ramen-bnb.svg": 1831,
	"./degens/ramen-busd.svg": 1832,
	"./degens/salt-bnb.png": 1833,
	"./degens/salt-busd.png": 1834,
	"./degens/sdump-bnb.png": 1835,
	"./degens/sdump-busd.png": 1836,
	"./degens/slime-bnb.png": 1837,
	"./degens/slime-busd.png": 1838,
	"./degens/tndr-bnb.png": 1839,
	"./degens/tndr-busd.png": 1840,
	"./degens/tofy-bnb.png": 1841,
	"./degens/tofy-mash.png": 1842,
	"./degens/tofy.png": 1843,
	"./deposited_outline.png": 918,
	"./eth-pairs/ADA-ETH.svg": 1844,
	"./eth-pairs/BETH-ETH.svg": 1845,
	"./eth-pairs/BTCB-ETH.svg": 1846,
	"./eth-pairs/ETH-BNB.png": 1847,
	"./eth-pairs/ETH-BTC.png": 1848,
	"./fantom/AAVE-FTM.png": 1849,
	"./fantom/ANY-FTM.png": 1850,
	"./fantom/BADGER-FTM.png": 1851,
	"./fantom/BAND-FTM.png": 1852,
	"./fantom/BIFI-FTM.png": 1853,
	"./fantom/BNB-FTM.png": 1854,
	"./fantom/BOO-FTM.png": 1855,
	"./fantom/BOO.png": 1856,
	"./fantom/BTC-FTM.png": 1857,
	"./fantom/COVER-FTM.png": 1858,
	"./fantom/CREAM-FTM.png": 1859,
	"./fantom/CRV-FTM.png": 1860,
	"./fantom/DAI-FTM.png": 1861,
	"./fantom/Dance of The Degens.png": 1862,
	"./fantom/EST-FTM.png": 1863,
	"./fantom/EST.png": 1864,
	"./fantom/ETH-FTM.png": 1865,
	"./fantom/FROYO-3Pool.png": 1866,
	"./fantom/FROYO.png": 1867,
	"./fantom/Fantom Conservatory.png": 1868,
	"./fantom/Fantom Sonata.png": 1869,
	"./fantom/Fantom of the Opera.png": 1870,
	"./fantom/Guqin Qi 2.png": 1871,
	"./fantom/Guqin Qi.png": 1872,
	"./fantom/ICE-FTM.png": 1873,
	"./fantom/LINK-FTM.png": 1874,
	"./fantom/Late Quartet.png": 1875,
	"./fantom/SNX-FTM.png": 1876,
	"./fantom/SUSHI-FTM.png": 1877,
	"./fantom/Song Of Ice And Fire.png": 1878,
	"./fantom/Sound of Moosic.png": 1879,
	"./fantom/Steady Beets.png": 1880,
	"./fantom/Symphony Nr 10.png": 1881,
	"./fantom/TOMB-FTM.png": 1882,
	"./fantom/TSHARE-FTM.png": 1883,
	"./fantom/The B Major.png": 1884,
	"./fantom/The Classic Trio.png": 1885,
	"./fantom/The E Major.png": 1886,
	"./fantom/The Fidelio Duetto.png": 1887,
	"./fantom/The Grand Orchestra.png": 1888,
	"./fantom/The Magic Touch By Daniele.png": 1889,
	"./fantom/Tubular Bells.png": 1890,
	"./fantom/USDC-FTM.png": 1891,
	"./fantom/USDT-FTM.png": 1892,
	"./fantom/WOOFY-FTM.png": 1893,
	"./fantom/YFI-FTM.png": 1894,
	"./fantom/Ziggy Stardust & Magic Internet Money.png": 1895,
	"./fantom/baron-von-binance.png": 1896,
	"./fantom/phantom-dai-opera.png": 1897,
	"./heco/AAVE-USDT.svg": 1898,
	"./heco/BAL-USDT.svg": 1899,
	"./heco/ETH-USDT.png": 1900,
	"./heco/ETH-WHT.svg": 1901,
	"./heco/HBCH-USDT.svg": 1902,
	"./heco/HBTC-USDT.png": 1903,
	"./heco/HBTC-WHT.svg": 1904,
	"./heco/HDOT-USDT.svg": 1905,
	"./heco/HFI-HT.png": 1906,
	"./heco/HFI-HUSD.png": 1907,
	"./heco/HFIL-USDT.svg": 1908,
	"./heco/HLTC-USDT.svg": 1909,
	"./heco/HPT-USDT.svg": 1910,
	"./heco/HUSD-USDT.svg": 1911,
	"./heco/HUSD.png": 1912,
	"./heco/LAVA-HT.svg": 1913,
	"./heco/LAVA-USDT.svg": 1914,
	"./heco/LAVA.png": 1915,
	"./heco/LHB-USDT.svg": 1916,
	"./heco/LHB-WHT.png": 1917,
	"./heco/LINK-USDT.svg": 1918,
	"./heco/MDX-USDT.png": 1919,
	"./heco/MDX-WHT.png": 1920,
	"./heco/SNX-USDT.svg": 1921,
	"./heco/UNI-USDT.svg": 1922,
	"./heco/WHT-HUSD.png": 1923,
	"./heco/WHT-USDT.png": 1924,
	"./heco/YFI-USDT.svg": 1925,
	"./heco/fHT.png": 1926,
	"./heco/fUNI.png": 1927,
	"./kebab/ETH-BTCB.png": 1928,
	"./kebab/KEBAB-BTCB.png": 1929,
	"./kebab/USDT-BUSD.png": 1930,
	"./menu/blog.png": 1931,
	"./menu/contact.png": 1932,
	"./menu/doc.png": 1933,
	"./menu/home.png": 1934,
	"./menu/vote.png": 1935,
	"./peghub.png": 295,
	"./phub_outline.png": 919,
	"./polygon/AAVE-ETH.png": 1936,
	"./polygon/ADDY.png": 1937,
	"./polygon/ANY-QUICK.png": 1938,
	"./polygon/AZUKI-ETH.png": 1939,
	"./polygon/BIFI-ETH.png": 1940,
	"./polygon/BIFI-MATIC.png": 1941,
	"./polygon/BIFI-MUST.png": 1942,
	"./polygon/BIFI-QUICK.png": 1943,
	"./polygon/BTC-USDC.png": 1944,
	"./polygon/CC10-ETH.png": 1945,
	"./polygon/CC10-QUICK.png": 1946,
	"./polygon/CEL-ETH.png": 1947,
	"./polygon/CRV-ETH.png": 1948,
	"./polygon/CURVE-3Pool.png": 1949,
	"./polygon/DEFI5-ETH.png": 1950,
	"./polygon/DEFI5-QUICK.png": 1951,
	"./polygon/DEGEN-ETH.png": 1952,
	"./polygon/DEGEN-QUICK.png": 1953,
	"./polygon/DOKI-ETH.png": 1954,
	"./polygon/ETH-BTC.png": 1955,
	"./polygon/ETH-DAI.png": 1956,
	"./polygon/ETH-FIL.png": 1957,
	"./polygon/ETH-MATIC.png": 1958,
	"./polygon/ETH-USDT.png": 1959,
	"./polygon/FFF-QUICK.png": 1960,
	"./polygon/FISH-MATIC.svg": 1961,
	"./polygon/FRAX-FXS.png": 1962,
	"./polygon/FRAX-QUICK.png": 1963,
	"./polygon/FRAX-USDC.png": 1964,
	"./polygon/GRT-ETH.png": 1965,
	"./polygon/IRON-ETH.png": 1966,
	"./polygon/IRON-USDC.png": 1967,
	"./polygon/IRON.png": 1968,
	"./polygon/KRILL-USDC.png": 1969,
	"./polygon/LINK-ETH.png": 1970,
	"./polygon/LINK-QUICK.png": 1971,
	"./polygon/MATIC-USDC.png": 1972,
	"./polygon/MATIC-WOOFY.png": 1973,
	"./polygon/MIMATIC-USDC.png": 1974,
	"./polygon/MUST-ETH.png": 1975,
	"./polygon/MUST-MATIC.png": 1976,
	"./polygon/PZAP-MATIC.png": 1977,
	"./polygon/PZAP-USDC.png": 1978,
	"./polygon/QUICK-ETH.png": 1979,
	"./polygon/QUICK-MATIC.png": 1980,
	"./polygon/QUICK-UNI.png": 1981,
	"./polygon/SNX-ETH.png": 1982,
	"./polygon/TITAN-ETH.png": 1983,
	"./polygon/TITAN-IRON.png": 1984,
	"./polygon/TITAN-MATIC.png": 1985,
	"./polygon/TITAN.png": 1986,
	"./polygon/UBT-ETH.png": 1987,
	"./polygon/USDC-DAI.png": 1988,
	"./polygon/USDC-ETH.png": 1989,
	"./polygon/USDC-MUST.png": 1990,
	"./polygon/USDC-USDT.png": 1991,
	"./polygon/VISION-ETH.png": 1992,
	"./polygon/VISION-QUICK.png": 1993,
	"./polygon/WEX-MATIC.png": 1994,
	"./polygon/WEX-USDC.png": 1995,
	"./polygon/WEX.png": 1996,
	"./polygon/WEXPOLY-BTC.png": 1997,
	"./polygon/WISE-ETH.png": 1998,
	"./polygon/mOCEAN-MATIC.png": 1999,
	"./polygon/maUSDC-USDC.png": 2000,
	"./polygon/renDOGE-ETH.png": 2001,
	"./single-assets/AAVE.svg": 580,
	"./single-assets/AAVEe.svg": 581,
	"./single-assets/ADA.svg": 582,
	"./single-assets/ADX.svg": 583,
	"./single-assets/ALPACA.png": 584,
	"./single-assets/ALPHA.png": 585,
	"./single-assets/AMPL.png": 586,
	"./single-assets/ANN.png": 587,
	"./single-assets/ANY.png": 588,
	"./single-assets/ARBITRUM.svg": 589,
	"./single-assets/ATOM.png": 590,
	"./single-assets/AURO.png": 591,
	"./single-assets/AVALANCHE.svg": 592,
	"./single-assets/AVAX.png": 593,
	"./single-assets/AVAX.svg": 594,
	"./single-assets/AXS.png": 595,
	"./single-assets/BABY.svg": 596,
	"./single-assets/BABYCAKE.svg": 597,
	"./single-assets/BAKE.png": 598,
	"./single-assets/BALL.png": 599,
	"./single-assets/BANANA.svg": 600,
	"./single-assets/BCH.svg": 601,
	"./single-assets/BDO.png": 602,
	"./single-assets/BDP.png": 603,
	"./single-assets/BEAR.png": 604,
	"./single-assets/BETA.svg": 605,
	"./single-assets/BETH.png": 606,
	"./single-assets/BETU.png": 607,
	"./single-assets/BHC.png": 608,
	"./single-assets/BIFI.png": 609,
	"./single-assets/BISON.png": 610,
	"./single-assets/BITADA.png": 611,
	"./single-assets/BITATOM.png": 612,
	"./single-assets/BITBTC.png": 613,
	"./single-assets/BITDOT.png": 614,
	"./single-assets/BITSHARE.png": 615,
	"./single-assets/BLZZ.svg": 616,
	"./single-assets/BMON.svg": 617,
	"./single-assets/BNB.png": 618,
	"./single-assets/BOMB.png": 619,
	"./single-assets/BONE.png": 620,
	"./single-assets/BONEswap.png": 621,
	"./single-assets/BOO.png": 622,
	"./single-assets/BORING.png": 623,
	"./single-assets/BP.png": 624,
	"./single-assets/BREW.png": 625,
	"./single-assets/BSC.svg": 626,
	"./single-assets/BSCDEFI.svg": 627,
	"./single-assets/BSCPAD.png": 628,
	"./single-assets/BSHARE.png": 629,
	"./single-assets/BTC.svg": 630,
	"./single-assets/BTCB.svg": 631,
	"./single-assets/BTD.png": 632,
	"./single-assets/BTS.png": 633,
	"./single-assets/BTT.png": 634,
	"./single-assets/BUNNY.png": 635,
	"./single-assets/BURGER.png": 636,
	"./single-assets/BUSD.svg": 637,
	"./single-assets/BUSDe.svg": 638,
	"./single-assets/BUSM.png": 639,
	"./single-assets/CAKE.svg": 640,
	"./single-assets/CAPS.svg": 641,
	"./single-assets/CARROT.png": 642,
	"./single-assets/CEEK.png": 643,
	"./single-assets/CELO.svg": 644,
	"./single-assets/CHESS.svg": 645,
	"./single-assets/CRA.png": 646,
	"./single-assets/CRO.svg": 647,
	"./single-assets/CRONA.svg": 648,
	"./single-assets/CRONOS.svg": 649,
	"./single-assets/CRV.png": 650,
	"./single-assets/CRYSTL.png": 651,
	"./single-assets/CTK.png": 652,
	"./single-assets/CYT.png": 653,
	"./single-assets/CZBNB.png": 654,
	"./single-assets/CZBOMB.png": 655,
	"./single-assets/CZBUSD.png": 656,
	"./single-assets/CZEMP.png": 657,
	"./single-assets/CZF.png": 658,
	"./single-assets/CZSHARES.png": 659,
	"./single-assets/DAI.png": 660,
	"./single-assets/DAI.svg": 661,
	"./single-assets/DAIe.png": 662,
	"./single-assets/DAR.svg": 663,
	"./single-assets/DELIRIUM.png": 664,
	"./single-assets/DEP.png": 665,
	"./single-assets/DFYN.png": 666,
	"./single-assets/DG.png": 667,
	"./single-assets/DINO.png": 668,
	"./single-assets/DIS.svg": 669,
	"./single-assets/DKT.png": 670,
	"./single-assets/DOGE.svg": 671,
	"./single-assets/DOLA.png": 672,
	"./single-assets/DOT.png": 673,
	"./single-assets/DPI.png": 674,
	"./single-assets/DRUGS.png": 675,
	"./single-assets/DVI.svg": 676,
	"./single-assets/ELK.png": 677,
	"./single-assets/EMP.png": 678,
	"./single-assets/EPS.png": 679,
	"./single-assets/ETERNAL.png": 680,
	"./single-assets/ETH.svg": 681,
	"./single-assets/EURt.png": 682,
	"./single-assets/EXP.svg": 683,
	"./single-assets/EZ.png": 684,
	"./single-assets/FANTOM.svg": 685,
	"./single-assets/FET.png": 686,
	"./single-assets/FFF.png": 687,
	"./single-assets/FIL.svg": 688,
	"./single-assets/FINN.png": 689,
	"./single-assets/FISH.svg": 690,
	"./single-assets/FOO.png": 691,
	"./single-assets/FORM.svg": 692,
	"./single-assets/FOX.png": 693,
	"./single-assets/FRAX.svg": 694,
	"./single-assets/FRUIT.png": 695,
	"./single-assets/FTM.png": 696,
	"./single-assets/FXS.png": 697,
	"./single-assets/GEIST.svg": 698,
	"./single-assets/GHST.png": 699,
	"./single-assets/GNT.png": 700,
	"./single-assets/GOLDCOIN.svg": 701,
	"./single-assets/GUARD.svg": 702,
	"./single-assets/HAI.png": 703,
	"./single-assets/HARD.png": 704,
	"./single-assets/HARMONY.svg": 705,
	"./single-assets/HBTC.png": 706,
	"./single-assets/HECO.svg": 707,
	"./single-assets/HERO.png": 708,
	"./single-assets/HONEY.png": 709,
	"./single-assets/HONOR.png": 710,
	"./single-assets/HOTCROSS.svg": 711,
	"./single-assets/HPS.png": 712,
	"./single-assets/HT.png": 713,
	"./single-assets/HTB.svg": 714,
	"./single-assets/HUSD.png": 715,
	"./single-assets/ICA.svg": 716,
	"./single-assets/ICE.png": 717,
	"./single-assets/IF.svg": 718,
	"./single-assets/INCH.png": 719,
	"./single-assets/INJ.png": 720,
	"./single-assets/INV.png": 721,
	"./single-assets/IRON.png": 722,
	"./single-assets/JETS.png": 723,
	"./single-assets/JOE.png": 724,
	"./single-assets/JRT.png": 725,
	"./single-assets/JULD.png": 726,
	"./single-assets/JUST.png": 727,
	"./single-assets/KART.png": 728,
	"./single-assets/KEBAB.png": 729,
	"./single-assets/KRW.png": 730,
	"./single-assets/LAND.svg": 731,
	"./single-assets/LAZIO.png": 732,
	"./single-assets/LINK.png": 733,
	"./single-assets/LINKe.png": 734,
	"./single-assets/LITHIUM.svg": 735,
	"./single-assets/LONG.png": 736,
	"./single-assets/LTC.svg": 737,
	"./single-assets/LUNA.png": 738,
	"./single-assets/MAI.png": 739,
	"./single-assets/MANA.png": 740,
	"./single-assets/MARSH.png": 741,
	"./single-assets/MASK.svg": 742,
	"./single-assets/MATIC.svg": 743,
	"./single-assets/MCB.png": 744,
	"./single-assets/MCRN.svg": 745,
	"./single-assets/MDX.png": 746,
	"./single-assets/MERL.svg": 747,
	"./single-assets/METAHERO.svg": 748,
	"./single-assets/MIM.png": 749,
	"./single-assets/MOON.png": 750,
	"./single-assets/MOONRIVER.svg": 751,
	"./single-assets/MOVR.png": 752,
	"./single-assets/MSC.png": 753,
	"./single-assets/MSS.png": 754,
	"./single-assets/MUST.png": 755,
	"./single-assets/NAOS.png": 756,
	"./single-assets/NEXO.png": 757,
	"./single-assets/NFT.png": 758,
	"./single-assets/NFTY.png": 759,
	"./single-assets/NUGGET.svg": 760,
	"./single-assets/NUTS.png": 761,
	"./single-assets/NYA.png": 762,
	"./single-assets/NYAC.png": 763,
	"./single-assets/NYAS.png": 764,
	"./single-assets/O3.png": 765,
	"./single-assets/OASIS.svg": 766,
	"./single-assets/OCP.png": 767,
	"./single-assets/ONE.svg": 768,
	"./single-assets/ONG.svg": 769,
	"./single-assets/ONT.png": 770,
	"./single-assets/OOE.svg": 771,
	"./single-assets/ORBS.svg": 772,
	"./single-assets/PACOCA.svg": 773,
	"./single-assets/PAUTO.png": 774,
	"./single-assets/PBNB.png": 775,
	"./single-assets/PEAR.svg": 776,
	"./single-assets/PERA.png": 777,
	"./single-assets/PETS.png": 778,
	"./single-assets/PHA.png": 779,
	"./single-assets/PHUB.png": 780,
	"./single-assets/PMATIC.png": 781,
	"./single-assets/PMP.svg": 782,
	"./single-assets/PNG.svg": 783,
	"./single-assets/POLYGON.svg": 784,
	"./single-assets/PORTO.png": 785,
	"./single-assets/POTS.png": 786,
	"./single-assets/PUP.png": 787,
	"./single-assets/PolyDoge.png": 788,
	"./single-assets/QBT.svg": 789,
	"./single-assets/QI.png": 790,
	"./single-assets/QUICK.png": 791,
	"./single-assets/RABBIT.svg": 792,
	"./single-assets/RAMP.png": 793,
	"./single-assets/RELAY.png": 794,
	"./single-assets/REVV.svg": 795,
	"./single-assets/RIB.png": 796,
	"./single-assets/ROUTE.png": 797,
	"./single-assets/RPG.png": 798,
	"./single-assets/SAGE.png": 799,
	"./single-assets/SBDO.png": 800,
	"./single-assets/SCREAM.png": 801,
	"./single-assets/SFP.png": 802,
	"./single-assets/SFUND.png": 803,
	"./single-assets/SHADE.png": 804,
	"./single-assets/SHIB.png": 805,
	"./single-assets/SHIBX.png": 806,
	"./single-assets/SING.png": 807,
	"./single-assets/SISTA.svg": 808,
	"./single-assets/SKILL.svg": 809,
	"./single-assets/SMART.png": 810,
	"./single-assets/SNX.png": 811,
	"./single-assets/SOAK.png": 812,
	"./single-assets/SOL.png": 813,
	"./single-assets/SOLAR.png": 814,
	"./single-assets/SPADE.png": 815,
	"./single-assets/SPELL.png": 816,
	"./single-assets/SPIRIT.png": 817,
	"./single-assets/SPS.svg": 818,
	"./single-assets/STARS.svg": 819,
	"./single-assets/START.png": 820,
	"./single-assets/STEAK.png": 821,
	"./single-assets/STEEL.png": 822,
	"./single-assets/SUMMIT.png": 823,
	"./single-assets/SUSHI.png": 824,
	"./single-assets/SUSHIe.png": 825,
	"./single-assets/SWAMP.svg": 826,
	"./single-assets/SX.png": 827,
	"./single-assets/SXP.svg": 828,
	"./single-assets/SYN.svg": 829,
	"./single-assets/TAPE.svg": 830,
	"./single-assets/TEL.png": 831,
	"./single-assets/TENFI.png": 832,
	"./single-assets/TETU.svg": 833,
	"./single-assets/TIME.png": 834,
	"./single-assets/TITAN.svg": 835,
	"./single-assets/TLOS.svg": 836,
	"./single-assets/TREEB.png": 837,
	"./single-assets/TRX.png": 838,
	"./single-assets/TUSD.png": 839,
	"./single-assets/TYPH.png": 840,
	"./single-assets/UFT.png": 841,
	"./single-assets/UNI.png": 842,
	"./single-assets/UNIe.png": 843,
	"./single-assets/USDC.svg": 844,
	"./single-assets/USDCe.svg": 845,
	"./single-assets/USDO.png": 846,
	"./single-assets/USDT.svg": 847,
	"./single-assets/USDTe.svg": 848,
	"./single-assets/UST.png": 849,
	"./single-assets/VVS.svg": 850,
	"./single-assets/WAN.svg": 851,
	"./single-assets/WATCH.png": 852,
	"./single-assets/WAULTx.svg": 853,
	"./single-assets/WBNB.svg": 854,
	"./single-assets/WBTC.svg": 855,
	"./single-assets/WBTCe.svg": 856,
	"./single-assets/WETH.svg": 857,
	"./single-assets/WETHe.svg": 858,
	"./single-assets/WEX.svg": 859,
	"./single-assets/WEXpoly.png": 860,
	"./single-assets/WIN.png": 861,
	"./single-assets/WMATIC.svg": 862,
	"./single-assets/WMATIC_DFYN.svg": 863,
	"./single-assets/WOO.svg": 864,
	"./single-assets/WOOFY.png": 865,
	"./single-assets/WSG.svg": 866,
	"./single-assets/WUSD.svg": 867,
	"./single-assets/XAVA.png": 868,
	"./single-assets/XRP.svg": 869,
	"./single-assets/XTZ.png": 870,
	"./single-assets/XVS.png": 871,
	"./single-assets/XWG.png": 872,
	"./single-assets/YAMP.svg": 873,
	"./single-assets/YEL.svg": 874,
	"./single-assets/YELD.png": 875,
	"./single-assets/YFI.png": 876,
	"./single-assets/YFIe.png": 877,
	"./single-assets/YGG.png": 878,
	"./single-assets/ZBTC.svg": 879,
	"./single-assets/ZETH.svg": 880,
	"./single-assets/ZOO.png": 881,
	"./single-assets/aQI.png": 882,
	"./single-assets/aROME.png": 883,
	"./single-assets/anyMTLX.png": 884,
	"./single-assets/bQI.png": 885,
	"./single-assets/bscBUSD.svg": 886,
	"./single-assets/cEUR.png": 887,
	"./single-assets/cUSD.png": 888,
	"./single-assets/cakeHARD.png": 889,
	"./single-assets/cakeROOBEE.png": 890,
	"./single-assets/cakeSTAX.png": 891,
	"./single-assets/cakeTWT.png": 892,
	"./single-assets/cakebROOBEE.png": 893,
	"./single-assets/fUSD.png": 894,
	"./single-assets/fUSDT.png": 895,
	"./single-assets/fWINGS.svg": 896,
	"./single-assets/ibBTC.svg": 897,
	"./single-assets/jCHF.png": 898,
	"./single-assets/jEUR.png": 899,
	"./single-assets/jGBP.png": 900,
	"./single-assets/miMatic.png": 901,
	"./single-assets/pBREW.png": 902,
	"./single-assets/pOPEN.webp": 903,
	"./single-assets/pWINGS.png": 904,
	"./single-assets/polyBUNNY.png": 905,
	"./single-assets/polyWISE.png": 906,
	"./single-assets/rUSD.svg": 907,
	"./single-assets/renBTC.png": 908,
	"./single-assets/renBTC.svg": 909,
	"./single-assets/renDGB.svg": 910,
	"./single-assets/renDOGE.png": 911,
	"./single-assets/sALPACA.svg": 912,
	"./single-assets/sSPELL.png": 913,
	"./single-assets/wMEMO.png": 914,
	"./single-assets/xMARK.png": 915,
	"./single-assets/xYELD.svg": 916,
	"./stake/annex/bg.png": 2002,
	"./stake/annex/logo.png": 2003,
	"./stake/apeswap/background.png": 2004,
	"./stake/apeswap/logo.png": 2005,
	"./stake/apyswap/background.png": 2006,
	"./stake/apyswap/logo.png": 2007,
	"./stake/astronaut/background.png": 2008,
	"./stake/astronaut/logo.png": 2009,
	"./stake/babyswap/bg.png": 2010,
	"./stake/babyswap/logo.png": 2011,
	"./stake/beefy/background.png": 2012,
	"./stake/beefy/beefyfinance.png": 2013,
	"./stake/beefy/beefyfinance_night.png": 2014,
	"./stake/betu/bg.png": 2015,
	"./stake/betu/logo.png": 2016,
	"./stake/billionhappiness/background.png": 2017,
	"./stake/billionhappiness/logo.png": 2018,
	"./stake/bingo/background.png": 2019,
	"./stake/bingo/logo.png": 2020,
	"./stake/bishares/bg.png": 2021,
	"./stake/bishares/logo.png": 2022,
	"./stake/biticity/background.png": 2023,
	"./stake/biticity/logo.png": 2024,
	"./stake/blockmine/bg.png": 2025,
	"./stake/blockmine/logo.png": 2026,
	"./stake/boneswap/background.png": 2027,
	"./stake/boneswap/logo.png": 2028,
	"./stake/boost.svg": 296,
	"./stake/cafeswap/background.png": 2029,
	"./stake/cafeswap/bg.png": 2030,
	"./stake/cafeswap/brew.png": 2031,
	"./stake/cafeswap/cafeswap.png": 2032,
	"./stake/cafeswap/logo.png": 2033,
	"./stake/ceek/bg.png": 2034,
	"./stake/ceek/logo.png": 2035,
	"./stake/crowfinance/background.png": 2036,
	"./stake/crowfinance/crow.png": 2037,
	"./stake/crowfinance/crowfinance.png": 2038,
	"./stake/czodiac/bg.png": 2039,
	"./stake/czodiac/logo.png": 2040,
	"./stake/dep/bg.png": 2041,
	"./stake/dep/logo.png": 2042,
	"./stake/dopple/background.png": 2043,
	"./stake/dopple/logo.png": 2044,
	"./stake/dumpling/background.png": 2045,
	"./stake/dumpling/logo.png": 2046,
	"./stake/elk/bg.png": 2047,
	"./stake/elk/logo.png": 2048,
	"./stake/esterfinance/background.png": 2049,
	"./stake/esterfinance/logo.png": 2050,
	"./stake/f1.png": 920,
	"./stake/fanatics/logo.png": 2051,
	"./stake/farmhero/bg.png": 2052,
	"./stake/farmhero/logo.png": 2053,
	"./stake/fire.png": 921,
	"./stake/fruit/background.png": 2054,
	"./stake/fruit/logo.png": 2055,
	"./stake/gamexchange/bg.png": 2056,
	"./stake/gamexchange/logo.png": 2057,
	"./stake/garuda/logo.png": 2058,
	"./stake/grandbanks/background.png": 2059,
	"./stake/grandbanks/logo.png": 2060,
	"./stake/honey/bg.png": 2061,
	"./stake/honey/logo.png": 2062,
	"./stake/huckleberry/bg.png": 2063,
	"./stake/huckleberry/logo.png": 2064,
	"./stake/icarus/background.png": 2065,
	"./stake/icarus/logo.png": 2066,
	"./stake/ironfinance/background.png": 2067,
	"./stake/ironfinance/logo.png": 2068,
	"./stake/jarvis/bg.png": 2069,
	"./stake/jarvis/logo.png": 2070,
	"./stake/jetswap/background.png": 2071,
	"./stake/jetswap/logo.png": 2072,
	"./stake/krown/background.png": 2073,
	"./stake/krown/logo.png": 2074,
	"./stake/landshare/bg.png": 2075,
	"./stake/landshare/logo.png": 2076,
	"./stake/launchpool.png": 922,
	"./stake/longdrink/bg.png": 2077,
	"./stake/longdrink/logo.png": 2078,
	"./stake/mash/background.png": 2079,
	"./stake/mash/logo.png": 2080,
	"./stake/memefarm/ape.png": 2081,
	"./stake/memefarm/background.png": 2082,
	"./stake/memefarm/logo.png": 2083,
	"./stake/merlin/background.png": 2084,
	"./stake/merlin/logo.png": 2085,
	"./stake/mogul/bg.png": 2086,
	"./stake/mogul/logo.png": 2087,
	"./stake/moonpot/bg.png": 2088,
	"./stake/moonpot/logo.png": 2089,
	"./stake/nfty/bg.png": 2090,
	"./stake/nfty/logo.png": 2091,
	"./stake/oasis/bg.png": 2092,
	"./stake/oasis/logo.png": 2093,
	"./stake/omnifarm/bg.png": 2094,
	"./stake/omnifarm/logo.png": 2095,
	"./stake/pacoca/bg.png": 2096,
	"./stake/pacoca/logo.png": 2097,
	"./stake/panther/background.png": 2098,
	"./stake/panther/logo.png": 2099,
	"./stake/pearzap/bg.png": 2100,
	"./stake/pearzap/logo.png": 2101,
	"./stake/pera/bg.png": 2102,
	"./stake/pera/logo.png": 2103,
	"./stake/polyalpha/bg.png": 2104,
	"./stake/polyalpha/logo.png": 2105,
	"./stake/polycracker/bg.png": 2106,
	"./stake/polycracker/logo.png": 2107,
	"./stake/polyfarm/bg.png": 2108,
	"./stake/polyfarm/logo.png": 2109,
	"./stake/polygon/background.png": 2110,
	"./stake/polygon/logo.png": 2111,
	"./stake/polypup/background.png": 2112,
	"./stake/polypup/logo.png": 2113,
	"./stake/polysage/bg.png": 2114,
	"./stake/polysage/logo.png": 2115,
	"./stake/polywise/bg.png": 2116,
	"./stake/polywise/logo.png": 2117,
	"./stake/polyyeld/background.png": 2118,
	"./stake/polyyeld/logo.png": 2119,
	"./stake/qidao/background.png": 2120,
	"./stake/qidao/logo.png": 2121,
	"./stake/ramenswap/background.png": 2122,
	"./stake/ramenswap/ramen.png": 2123,
	"./stake/ramenswap/ramenswap.png": 2124,
	"./stake/safefarm/background.png": 2125,
	"./stake/safefarm/logo.png": 2126,
	"./stake/saltswap/background.png": 2127,
	"./stake/saltswap/salt.png": 2128,
	"./stake/saltswap/saltswap.png": 2129,
	"./stake/sandman/bg.png": 2130,
	"./stake/sandman/logo.png": 2131,
	"./stake/satis/background.png": 2132,
	"./stake/satis/logo.png": 2133,
	"./stake/scream/bg.png": 2134,
	"./stake/scream/logo.png": 2135,
	"./stake/singular/bg.png": 2136,
	"./stake/singular/logo.png": 2137,
	"./stake/slimefinance/background.png": 2138,
	"./stake/slimefinance/logo.png": 2139,
	"./stake/slimefinance/slime.png": 2140,
	"./stake/soup/background.png": 2141,
	"./stake/soup/logo.png": 2142,
	"./stake/space/background.png": 2143,
	"./stake/space/logo.png": 2144,
	"./stake/squirrel/background.png": 2145,
	"./stake/squirrel/logo.png": 2146,
	"./stake/squirrel/nuts.png": 2147,
	"./stake/swirl/background.png": 2148,
	"./stake/swirl/logo.png": 2149,
	"./stake/tenfi/background.png": 2150,
	"./stake/tenfi/logo.png": 2151,
	"./stake/ternoa/bg.png": 2152,
	"./stake/ternoa/logo.png": 2153,
	"./stake/tetu/bg.png": 2154,
	"./stake/tetu/logo.png": 2155,
	"./stake/thunder/background.png": 2156,
	"./stake/thunder/logo.png": 2157,
	"./stake/thypoon/background.png": 2158,
	"./stake/thypoon/logo.png": 2159,
	"./stake/tombfinance/background.png": 2160,
	"./stake/tombfinance/logo.png": 2161,
	"./stake/tosdis/bg.png": 2162,
	"./stake/tosdis/logo.png": 2163,
	"./stake/viralata/bg.png": 2164,
	"./stake/viralata/logo.png": 2165,
	"./stake/wolfden/bg.png": 2166,
	"./stake/wolfden/logo.png": 2167,
	"./stake/wsg/bg.png": 2168,
	"./stake/wsg/logo.png": 2169,
	"./stake/xbtc/background.png": 2170,
	"./stake/xbtc/logo.png": 2171,
	"./stake/xyeld/bg.png": 2172,
	"./stake/xyeld/logo.png": 2173,
	"./stake/xyeld/xyeld-matic.svg": 2174,
	"./stake/yel/bg.png": 2175,
	"./stake/yel/logo.png": 2176,
	"./stake/yieldbay/background.png": 2177,
	"./stake/yieldbay/logo.png": 2178,
	"./stake/yieldwatch/bg.png": 2179,
	"./stake/yieldwatch/logo.png": 2180,
	"./stake/zcore/background.png": 2181,
	"./stake/zcore/logo.png": 2182,
	"./uncategorized/3CRV.png": 2183,
	"./uncategorized/ATRICRYPTO.png": 2184,
	"./uncategorized/BADGER-BTCB.svg": 2185,
	"./uncategorized/BAT-BAKE.svg": 2186,
	"./uncategorized/BDIGG-BTCB.svg": 2187,
	"./uncategorized/BELT-VENUSBLP.png": 2188,
	"./uncategorized/BETH-ETH.svg": 2189,
	"./uncategorized/COMP-ETH.svg": 2190,
	"./uncategorized/DOPPLE-DOLLY-LP.svg": 2191,
	"./uncategorized/DOPPLE-DOP-LP.svg": 2192,
	"./uncategorized/DOPPLE-UST-LP.png": 2193,
	"./uncategorized/ETH-USDT.png": 2194,
	"./uncategorized/IRON-3USD.png": 2195,
	"./uncategorized/IRON3USD.png": 2196,
	"./uncategorized/MIM2CRV.svg": 2197,
	"./uncategorized/PNT-PBTC.svg": 2198,
	"./uncategorized/SUSHI-ETH.svg": 2199,
	"./uncategorized/TBTC-BTCB.svg": 2200,
	"./uncategorized/THUGS-NAR.png": 2201,
	"./uncategorized/bTRI-CRED.png": 2202,
	"./uncategorized/crv2pool.png": 2203,
	"./uncategorized/eps3.png": 2204,
	"./uncategorized/epsBNB.png": 2205,
	"./uncategorized/epsFUSDT.png": 2206,
	"./uncategorized/epsPBTC.png": 2207,
	"./uncategorized/epsRENBTC.png": 2208,
	"./uncategorized/epsUSDN.png": 2209,
	"./uncategorized/nUSD-LP.png": 2210,
	"./usdt-pairs/ALPACA-USDT.png": 2211,
	"./usdt-pairs/BIFI-USDT.png": 2212,
	"./usdt-pairs/BNB-USDT.png": 2213,
	"./usdt-pairs/BTCB-USDT.svg": 2214,
	"./usdt-pairs/ETH-USDT.svg": 2215,
	"./usdt-pairs/FIL-USDT.png": 2216,
	"./usdt-pairs/LHB-USDT.png": 2217,
	"./usdt-pairs/LYD-USDT.png": 2218,
	"./usdt-pairs/MATIC-USDT.png": 2219,
	"./usdt-pairs/SHIB-USDT.png": 2220,
	"./usdt-pairs/TUSD-USDT.png": 2221,
	"./usdt-pairs/WEX-USDT.png": 2222,
	"./ust-pairs/MAMZN-UST.svg": 2223,
	"./ust-pairs/MCOIN-UST.svg": 2224,
	"./ust-pairs/MGOOGL-UST.svg": 2225,
	"./ust-pairs/MIR-UST.svg": 2226,
	"./ust-pairs/MNFLX-UST.svg": 2227,
	"./ust-pairs/MTSLA-UST.svg": 2228,
	"./visa-mastercard-logos.png": 389,
	"./wallets/binance-wallet.png": 568,
	"./wallets/math-wallet.svg": 388,
	"./wallets/metamask.png": 2229,
	"./wallets/metamask.svg": 2230,
	"./wallets/safepal-wallet.svg": 570,
	"./wallets/trust-wallet.svg": 569
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 180;